/**
 * Contact info card — name, phone, email of the customer.
 */

import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui'
import { formatPhoneNumber } from '@/utils/formatting'
import type { CustomerInfo } from '@/types/customer'

interface OrderContactInfoCardProps {
  customerInfo: CustomerInfo
}

export function OrderContactInfoCard({ customerInfo }: OrderContactInfoCardProps) {
  const { t } = useTranslation()

  return (
    <Card className="mb-6">
      <CardHeader className="pb-2">
        <CardTitle className="text-base">{t('common:contactInformation')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2 text-sm">
          <div className="flex items-center justify-between">
            <span className="text-muted-foreground">{t('common:name')}</span>
            <span className="font-medium">
              {customerInfo.firstName} {customerInfo.lastName}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-muted-foreground">{t('common:phone')}</span>
            <span className="font-medium">
              {formatPhoneNumber(customerInfo.phone)}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-muted-foreground">{t('common:email')}</span>
            <span className="font-medium">{customerInfo.email}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
